import React from 'react';
import ReactDOM from 'react-dom/client';
import './Sass/Index.scss';
import Routes from './Rourtes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>
);
